var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{ref:"navbar",staticClass:"navbar navbar-expand-md container d-print-none",attrs:{"id":"navigation"}},[_c('div',{attrs:{"id":"navbarNav"}},[(_vm.navigationItemsWithMasking)?_c('NavigationItems',{attrs:{"entries":_vm.navigationItemsWithMasking}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }